export const FormLabelMixin = {
  props: {
    subLabel: {
      type: String,
      default: null
    },
    tooltipLabel: {
      type: String,
      default: null
    },
    rightSubLabel: {
      type: String,
      default: null
    },
    isVertical: {
      type: Boolean,
      default: false
    },
    hideIcon: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    hasTooltip() {
      return this.tooltipLabel && this.rightSubLabel;
    }
  }
};
